var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8583 22.8623C12.2371 23.2366 12.8477 23.2329 13.222 22.8541C13.5963 22.4753 13.5927 21.8647 13.2138 21.4904L6.10105 14.4621L23.1451 14.4621C23.6776 14.4621 24.1094 14.0303 24.1094 13.4978C24.1094 12.9652 23.6776 12.5335 23.1451 12.5335L6.10327 12.5335L13.2138 5.50731C13.5927 5.13297 13.5963 4.52239 13.222 4.14361C12.8477 3.76475 12.2371 3.76118 11.8583 4.13542L3.25014 12.6415C2.77263 13.1133 2.77263 13.8843 3.25014 14.3563L11.8583 22.8623Z",
    fill: "#606062"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftSvg);
export default __webpack_public_path__ + "static/media/arrow-left-svg.ed20c509a43a4fd1a7df0608c7f10a91.svg";
export { ForwardRef as ReactComponent };